import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35df8498&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=35df8498&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df8498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35df8498')) {
      api.createRecord('35df8498', component.options)
    } else {
      api.reload('35df8498', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35df8498&scoped=true", function () {
      api.rerender('35df8498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RouteFormDialog/index.vue"
export default component.exports